import { createApi, createCustomServiceCall } from '@thinknimble/tn-models'
import { axiosInstance } from '../axios-instance'
import {
  botTokenShape,
  createBotTokenShape,
  botTokenCreatedShape,
  botTokenFilterShape,
} from './models'

/**
 * Mint a bot token. Unlike the default `create`, the response carries the raw
 * `token` secret (surfaced exactly once), so it needs its own output shape.
 */
const createBotToken = createCustomServiceCall({
  inputShape: createBotTokenShape,
  outputShape: botTokenCreatedShape,
  cb: async ({ client, slashEndingBaseUri, input, utils: { fromApi, toApi } }) => {
    const response = await client.post(slashEndingBaseUri, toApi(input))
    return fromApi(response.data)
  },
})

export const botTokenApi = createApi({
  client: axiosInstance,
  baseUri: '/tokens/bot-tokens/',
  models: {
    entity: botTokenShape,
    extraFilters: botTokenFilterShape,
  },
  customCalls: {
    createBotToken,
  },
})
